import { Route, Switch } from "react-router-dom";
import CGV from "../CGV";
import CheckoutAccount from "../CheckoutAccount";
import CheckoutCart from "../CheckoutCart";
import CheckoutProcess from "../CheckoutProcess";
import CheckoutResponse from "../CheckoutResponse";
import Counter from "../Counter";
import CurrentClub from "../CurrentClub";
import Flex from "../UI/Flex";
import Footer from "../Footer";
import Header from "../Header";
import HomePage from "../HomePage";
import Page404 from "../Page404";
import PendingPage from "../PendingPage";
import ProductPage from "../ProductPage";
import PropTypes from "prop-types";
import React from "react";
import ShopPage from "../ShopPage";
import classes from "./Layout.module.css";

const NAVIGATION_ENABLED = +process.env.REACT_APP_ENABLED;

const Layout = ({ translate }) => (
  <div className={classes.layout}>
    <Header navigationEnabled={NAVIGATION_ENABLED} />
    <CurrentClub />

    <Flex size={1} className={classes.layout__content}>
      {NAVIGATION_ENABLED ? (
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/:clubId/shop" component={ShopPage} />
          <Route exact path="/:clubId/shop/:productId" component={ProductPage} />
          <Route exact path="/:clubId/checkout" component={CheckoutCart} />
          <Route exact path="/:clubId/checkout_process" component={CheckoutProcess} />
          <Route exact path="/checkout_response" component={CheckoutResponse} />
          <Route exact path="/:clubId/identification" component={CheckoutAccount} />
          <Route exact path="/counter" component={Counter} />
          <Route exact path="/CGV" component={CGV} />
          <Route component={Page404} />
        </Switch>
      ) : (
        <Switch>
          <Route exact path="/" component={PendingPage} />
          <Route component={Page404} />
        </Switch>
      )}
    </Flex>

    <Footer />
  </div>
);

Layout.propTypes = {
  translate: PropTypes.func.isRequired
};

export default Layout;



// WEBPACK FOOTER //
// ./src/app/components/Layout/Layout.js